<template>
  <v-card class="art-card pa-2" :to="{ name: 'art-info-general', params: { id } }">
    <v-img :src="imageUrl" :lazy-src="imageUrlLowRes" contain  />
    <h5 class="mt-2 px-2">{{ name_sve }}</h5>
  </v-card>
</template>

<script>
export default {
  props: {
    id: { type: Number },
    name_sve: { type: String },
    image: { type: Object },
  },
  computed: {
    imageId() {
      return this.image && this.image.li_image_id ? this.image.li_image_id : '' //TODO: Add placeholder
    },
    imageUrl() {
      return `${process.env.VUE_APP_IMAGE_BACKEND}/870/${this.imageId}.jpg`
    },
    imageUrlLowRes() {
      return `${process.env.VUE_APP_IMAGE_BACKEND}/170/${this.imageId}.jpg`
    },
  },
}
</script>

<style lang="less" scoped>
.art-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
